import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { EPrefix, IContact } from 'apps/idl/src/model';
import { DestroyableComponentBase } from 'apps/idl/src/modules/utils/components/destroyable-component-base';
import { ContactsService } from 'apps/idl/src/services/security';
import { IPatient } from 'apps/idl/src/modules/patients/model/IPatient';
import { map, takeUntil } from 'rxjs/operators';
import { MedecinService } from '../../../shared/services/medecin.service';
import { PanneauService } from '../../../shared/services/panneau.service';
import { ITraitement } from 'apps/idl/src/model/ITraitement';

@Component({
  selector: 'di-panneau-choix-medecin',
  templateUrl: './panneau-choix-medecin.component.html',
  styleUrls: ['./panneau-choix-medecin.component.scss'],
})
export class PanneauChoixMedecinComponent extends DestroyableComponentBase implements OnInit {

  // Patient fourni en cas de création d'ordonnance
  @Input()
  public patient?: IPatient;

  // Ordonnance fournie en cas d'édition d'ordonnance
  @Input()
  public ordonnance?: ITraitement;

  public contacts: IContact[];

  constructor(
    private svcContacts: ContactsService,
    private svcPanneau: PanneauService,
    private svcMedecin: MedecinService,
    private router: Router) {
    super()
  }

  ngOnInit() {
    this.svcContacts.getSiteContactsAnakin([], EPrefix.contact, true, false).pipe(
      map((contacts: IContact[]) => {
        return contacts.map((contact: IContact) => {
          if (!contact.isDoctor && contact.finess)
            contact.isDoctor = true;
          return contact;
        });
      }),
      takeUntil(this.destroyed$)
    ).subscribe((contacts: IContact[]) => {
      this.contacts = contacts.filter(contact => contact.isDoctor);
    });
  }

  public selectContact(contactId: string) {
    this.svcMedecin.emitSelectMedecin(contactId)
    this.svcPanneau.close();
  }

  handleClickAddContact() {
    this.svcPanneau.close();
    let state = {};
    if (this.patient) {
      state = { route: ['ordonnances', 'add'], context: 'ordonnance', mode: 'add', patient: this.patient };
    } else if (this.ordonnance) {
      state = { route: ['ordonnances', 'edit', this.ordonnance._id], context: 'ordonnance', mode: 'edit', };
    }
    this.router.navigate(["contacts", "add"], { state: state });
  }
}
